import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'
import Text from './Text'

const styles = StyleSheet.create({
  view: {
    marginTop: 15,
    marginBottom: 15,
    flexDirection: 'row',
  },
  column: {
    display: 'block',
  },
  icon: {
    marginRight: 8,
  },
  text: {
    marginTop: 4,
    fontSize: 10,
    marginRight: 24,
    color: colors.strongGray,
  },
  title: {
    color: colors.strongYellow,
    fontSize: 10,
    fontFamily: 'Inter-Bold',
  },
  line: {},
})

// Create Document Component
export const Important = ({ textColor, date, icon }) => {
  return (
    <View style={styles.view}>
      <View style={styles.icon}>{icon && icon(textColor)}</View>
      <View style={styles.column}>
        <Text style={styles.title}>IMPORTANTE</Text>
        <Text style={styles.text}>
          Agende suas consultas ou exames com a Unimed Assis através do telefone
          <Text style={{ fontFamily: 'Inter-Bold' }}>
            {' '}
            (18) 99709-1663
            {' '}
          </Text>
          ou pelo e-mail
          <Text style={{ fontFamily: 'Inter-Bold' }}>
            {' '}
            medicina.preventiva@unimed-assis.com.br
          </Text>
          . Para realizar qualquer procedimento no Ambulatório Essencial, é
          necessário levar os resultados dos exames realizados anteriormente.
          Este é um resultado preliminar com base nos dados coletados dia
          {' '}
          {date}
          . Para ter um diagnóstico completo sobre sua saúde, não deixe de
          seguir as recomendações contidas neste relatório e realizar consultas
          periódicas com seu médico.
        </Text>
      </View>
    </View>
  )
}

Important.propTypes = {
  date: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  icon: PropTypes.func,
}

Important.defaultProps = {
  icon: null,
  textColor: colors.titleStrongBlack,
}
